__turbopack_context__.v({
  "action": "EmailNotConfirmedPage-module-scss-module__TQnb9a__action",
  "content": "EmailNotConfirmedPage-module-scss-module__TQnb9a__content",
  "page": "EmailNotConfirmedPage-module-scss-module__TQnb9a__page",
  "spin": "EmailNotConfirmedPage-module-scss-module__TQnb9a__spin",
  "spinner": "EmailNotConfirmedPage-module-scss-module__TQnb9a__spinner",
});
